var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardText({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.95H13C13.41 11.95 13.75 11.61 13.75 11.2C13.75 10.79 13.41 10.45 13 10.45H6C5.59 10.45 5.25 10.79 5.25 11.2C5.25 11.61 5.59 11.95 6 11.95Z",
    fill: "#5D9FE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.95H10.38C10.79 15.95 11.13 15.61 11.13 15.2C11.13 14.79 10.79 14.45 10.38 14.45H6C5.59 14.45 5.25 14.79 5.25 15.2C5.25 15.61 5.59 15.95 6 15.95Z",
    fill: "#5D9FE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7087 2.32445C14.4356 0.25 12.8739 0.25 12 0.25H8C7.12491 0.25 5.56014 0.25 5.29019 2.33296C1.71756 2.72043 0.25 4.69953 0.25 9.00005V15.0001C0.25 19.1701 1.38 21.7501 7 21.7501H13C18.62 21.7501 19.75 19.1701 19.75 14.9901V8.99005C19.75 4.69851 18.2821 2.71998 14.7087 2.32445ZM12 5.75H8C7.14851 5.75 5.64404 5.75 5.31482 3.83106C2.95339 4.10804 1.75 5.15562 1.75 9.00005V15.0001C1.75 18.7001 2.48 20.2501 7 20.2501H13C17.52 20.2501 18.25 18.7001 18.25 15.0001V9.00005C18.25 5.16757 17.0541 4.11458 14.7072 3.83366C14.5785 4.74237 14.0633 5.75 12 5.75ZM13.25 3.05274C13.2496 3.99927 13.2275 4.25 12 4.25H8C7.02604 4.25 6.75862 4.25 6.75021 3.05978C6.75117 3.03685 6.75112 3.01364 6.75001 2.99017C6.75137 1.75 7.0126 1.75 8 1.75H12C12.9848 1.75 13.2473 1.75 13.25 2.98049C13.2488 3.00477 13.2488 3.02887 13.25 3.05274Z",
    fill: "#5D9FE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardText);
export default __webpack_public_path__ + "static/media/Clipboard_Text.6ae64be4c3a6bedf4f00c7a7d823dded.svg";
export { ForwardRef as ReactComponent };